import { OPEN_WEB_UI_URL, API_HOST } from '../../consts';
import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Container,
  Grid,
  Typography,
  Button,
  Paper,
  CircularProgress
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ThemeContext } from '../../contexts/ThemeContext';

const OpenWebUi = () => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const theme = useContext(ThemeContext);

  const StyleButton = withStyles(() => ({
    root: {
      borderRadius: "24px",
      border: "none",
      backgroundColor: theme.primary,
      padding: "12px 24px",
      color: "#ffffff",
      fontSize: "16px",
      fontWeight: "600",
      textAlign: "center",
      outline: "none",
      fontFamily: "Public Sans",
      textTransform: "capitalize",
      minWidth: "200px",
      "&:hover": {
        backgroundColor: theme.primaryDark,
        outline: "none"
      },
      "&:disabled": {
        color: "#ffffff",
        backgroundColor: theme.disabled
      }
    }
  }))(Button);

  const fetchMe = async () => {
    const token = localStorage.getItem('token');
    try {
      setLoading(true);
      const response = await axios.get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      const url = `${OPEN_WEB_UI_URL}/?email=${response.data.email}&name=${response.data.last_name}&groups=${response.data.logged_group}`;
      setIframeUrl(url);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChat = () => {
    if (iframeUrl) {
      window.open(iframeUrl, '_blank');
    }
  };

  useEffect(() => {
    fetchMe();
  }, []);

  return (
    <Container
      maxWidth="md"
      style={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        paddingTop: '6rem',
        paddingBottom: '2rem',
        background: theme.background
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: '3rem',
          borderRadius: '16px',
          textAlign: 'center',
          width: '100%',
          maxWidth: '600px',
          background: theme.surface,
          boxShadow: `0 10px 30px ${theme.shadow}`
        }}
      >
        <Grid container spacing={3} direction="column" alignItems="center">
          <Grid item>
            <Typography
              variant="h3"
              component="h1"
              style={{
                color: theme.primary,
                fontWeight: '700',
                fontSize: '2.5rem',
                marginBottom: '1rem',
                fontFamily: 'Public Sans'
              }}
            >
              Chat IA Educat
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant="body1"
              style={{
                color: theme.textSecondary,
                fontSize: '1.1rem',
                lineHeight: '1.6',
                marginBottom: '2rem',
                textAlign: 'justify',
                fontFamily: 'Public Sans'
              }}
            >
              Bem-vindo ao nosso assistente de inteligência artificial!
              Aqui você pode tirar dúvidas, obter ajuda com seus estudos e
              explorar conteúdos educacionais de forma interativa e personalizada.
              Nossa IA está pronta para auxiliá-lo em sua jornada de aprendizado.
            </Typography>
          </Grid>

          <Grid item>
            <StyleButton
              onClick={handleOpenChat}
              disabled={loading || !iframeUrl}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} style={{ color: '#ffffff' }} />
                  Carregando...
                </>
              ) : (
                <Typography
                  variant="body1"
                  style={{
                    color: '#FFFFFF',
                    fontSize: '1rem',
                    fontFamily: 'Public Sans'
                  }}
                >
                  Leve-me até lá
                </Typography>
              )}
            </StyleButton>
          </Grid>
        </Grid>
      </Paper>

      {/* <div>
        <iframe
          title="educat-ia"
          allowFullScreen
          src={iframeUrl}
          style={{ width: '100vw', height: '80vh' }}
        />
      </div> */}
    </Container>
  );
};

export default OpenWebUi;
